import { Box, Drawer, IconButton, List, ListItem, ListItemButton, ListItemText } from "@mui/material";
import { Dispatch, SetStateAction } from "react";
import CloseIcon from "@mui/icons-material/Close";
import { Link as RouterLink } from "react-router-dom";

export default function MobileMenu(props: {
    menuItems: { label: string; path: string }[];
    setMobileOpen: Dispatch<SetStateAction<boolean>>;
    mobileOpen: boolean;
    toggleDrawer: (open: boolean) => () => void;
}) {
    return (
        <Drawer
            anchor="left"
            open={props.mobileOpen}
            onClose={props.toggleDrawer(false)}
            slotProps={{
                backdrop: { sx: { bgcolor: "rgba(0,0,0,0.5)" } },
            }}
            PaperProps={{
                sx: {
                    width: "75%",
                    maxWidth: 300,
                    bgcolor: "primary.main",
                    color: "primary.contrastText",
                    pt: 8,
                    borderRadius: 0,
                },
            }}
        >
            <Box sx={{ display: "flex", justifyContent: "flex-end", p: 1 }}>
                <IconButton onClick={props.toggleDrawer(false)} color="inherit" aria-label="закрыть меню">
                    <CloseIcon />
                </IconButton>
            </Box>
            <List>
                {props.menuItems.map((item) => (
                    <ListItem key={item.path} disablePadding>
                        <ListItemButton
                            component={RouterLink}
                            to={item.path}
                            onClick={props.toggleDrawer(false)}
                            sx={{
                                color: "inherit",
                                "&:hover": { bgcolor: "rgba(255,255,255,0.08)" },
                            }}
                        >
                            <ListItemText primary={item.label} />
                        </ListItemButton>
                    </ListItem>
                ))}
            </List>
        </Drawer>
    );
}
